const useStyles = (theme) => ({
  dialogContent: {
    pt: "12px !important",
    pb: "12px !important",
    px: 3,
  },
  dialogTitle: {
    px: 3,
    pt: 2.5,
    pb: 0,
  },
  dialogActions: {
    px: 3,
    pb: 2.5,
    pt: 2,
    gap: 1,
  },
  textfield: {
    maxWidth: "100%",
    "& .MuiOutlinedInput-root": {
      backgroundColor: theme.palette.background.paperLinkedMaps,
      boxShadow: "none",
      "&:hover": {
        backgroundColor: theme.palette.background.paperLinkedMaps,
      },
    },
  },
  sectionNumber: {
    width: 24,
    height: 24,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontSize: "0.75rem",
    fontWeight: 700,
    flexShrink: 0,
  },
});

export default useStyles;
